const ELLIPSIS = '...';

export default (str, limit) => {
  if (str.length > limit) {
    return str.substr(str, limit - ELLIPSIS.length) + ELLIPSIS;
  }
  return str;
};
